import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PageBanner = ({ pageName = "", pageTitle = "", title = "" }) => {
  const { t } = useTranslation(); // Initialize translation

  useEffect(() => {
    document.documentElement.scrollTop = 0;
  }, []);

  return (
    <div className="breadcrumbs section-padding breadcrumb-mobile about-banner bg-cover bg-center bg-no-repeat">
      <div className="container text-center my-5">
        {/* Ensure the title is translated properly */}
        <h2 className="mb-5 mt-5">{t(`page_banner.${title}`, title)}</h2>

        {/* Breadcrumb Navigation */}
        <nav>
          <ol className="flex items-center justify-center space-x-3">
            <li className="breadcrumb-item">
              <Link to={"/"}> {t("page_banner.home", "Home")}</Link>
            </li>
            <li className="breadcrumb-item px-2"> - </li>
            <li className="text-primary">
              {t(`page_banner.${pageName}`, pageName)}{" "}
              {t(`page_banner.${pageTitle}`, pageTitle)}
            </li>
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default PageBanner;
